/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 * @param {event} event -Event submit from add to cart form
 */
export const addProductsPlp = async (event) => {
  const form = event.target.closest("form");
  if(form){
    const itemId = form.querySelector("input[name='id']").value;
    if(itemId){
      let currentbtn = event.currentTarget;

      let formData = {
        items: [
          {
            id: itemId,
            quantity: 1,
          },
        ],
      };
      currentbtn.setAttribute("disabled", "disabled");
      try {
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        await updateCartItems();
        currentbtn.removeAttribute("disabled");
        await openSideCart();
      } catch (error) {
        console.log("error add to cart ", error);
      }
    }
  }
}

/**
 * Opens the side cart and performs additional actions.
 * @returns {Promise} A promise that resolves when the side cart is opened.
 */
const openSideCart = () => {
  return new Promise((resolve) => {
    document.querySelector('.cart-link__icon').click()
  })
}

/**
 * Updates the cart items and returns a promise that resolves after a delay of 1 second.
 * @returns {Promise<void>} A promise that resolves after the cart items are updated.
 */
const updateCartItems = () => {
  return new Promise((resolve) => {
    document.documentElement.dispatchEvent(
      new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
      setTimeout(() => {
        resolve();

      }, 700);
  })

}
